import { createStore } from "solid-js/store";
import type { AuthStore } from "./types";

const [authStore, setAuthStore] = createStore<AuthStore>(
	{
		profile: null,
		token: null,
	},
	{ name: "AuthStore" },
);

export { authStore, setAuthStore };
